import { IData } from "../../game/Types/IData";

export abstract class Saver {
    protected abstract _dataCache: Record<string, unknown>;

    constructor() {/* abstract class */
    }

    public abstract save(data: Partial<IData>): Promise<void>;

    public abstract load(_keysToLoad?: string[]): Promise<IData>;

    public abstract clear(): Promise<void>;
}
